import * as v from 'valibot'

import {
  vBoolean,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPipe,
  vString,
  vStringToNumber,
} from '../validation/index.ts'

/**
 * Schema for calculating pricing based on shipment count
 */
export const calculatePricingSchema = vObject({
  shipments: vPipe(
    vNumber(),
    v.minValue(1, 'Shipment count must be at least 1'),
  ),
  includeMileage: vOptional(vBoolean(), false),
})

export type CalculatePricingRequest = vOutput<typeof calculatePricingSchema>

/**
 * Schema for generating a pricing proposal PDF
 */
export const generateProposalSchema = vObject({
  companyName: vOptional(vString()),
  salesRepName: vOptional(vString()),
  notes: vOptional(vString()),
  shipments: vPipe(
    vStringToNumber(),
    v.minValue(1, 'Shipment count must be at least 1'),
  ),
  includeMileage: vOptional(vBoolean(), false),
  customSubscriptionCost: vOptional(vNumber()),
  customCostPerShipment: vOptional(vNumber()),
})

export type GenerateProposalRequest = vOutput<typeof generateProposalSchema>

/**
 * Response from pricing calculation
 */
export interface PricingCalculationResponse {
  shipments: number
  subscriptionCost: number
  costPerShipment: number
  mileageSurcharge: number
  totalCost: number
  includeMileage: boolean
}

/**
 * Pricing tier configuration
 */
export interface PricingTier {
  shipments: number
  subscriptionCost: number
}

export const mileageSurchargeRate = 0.32
